import { DC } from "@/core/constants";

export const MatterScale = {
  proton: new Decimal("2.82e-45"),

  estimate(matter) {
    if (!matter) return ["Пока что здесь нет антиматерии."];
    if (matter.gt(DC.E100000)) {
      return [
        `Если бы вы писали ${formatInt(3)} числа в секунду, написание вашего количества антиматерии заняло бы у вас`,
        `${TimeSpan.fromSeconds(matter.log10() / 3).toString()}.`, ""
      ];
    }
    const planck = new Decimal("4.22419e-105");
    const planckedMatter = matter.times(planck);
    if (planckedMatter.gt(this.proton)) {
      const scale = this.macroScale(planckedMatter);
      const amount = format(planckedMatter.dividedBy(scale.amount), 2, 1);
      return [`Если бы объём каждой антиматерии был равен Планковскому объему, у вас было бы
        достаточно для ${scale.verb} ${amount} ${scale.name}`];
    }
    const scale = this.microScale(matter);
    return [`Если бы каждая антиматерия была ${format(this.proton.div(scale.amount).div(matter), 2, 1)} ${scale.name},
      у вас было бы достаточно для того чтобы сделать протон.`];
  },

  microScale(matter) {
    const micro = this.microObjects;
    for (let i = 0; i < micro.length; i++) {
      const scale = micro[i];
      if (matter.times(scale.amount).lt(this.proton)) {
        return scale;
      }
    }
    throw "Cannot determine smallest antimatter scale";
  },

  macroScale(matter) {
    const macro = this.macroObjects;
    const last = macro.last();
    if (matter.gte(last.amount)) return last;
    let low = 0;
    let high = macro.length;
    while (low !== high) {
      const mid = Math.floor((low + high) / 2);
      if (macro[mid].amount.lte(matter)) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return macro[high - 1];
  },

  microObjects: [
    { amount: new Decimal("1e-54"), name: "аттометров кубических" },
    { amount: new Decimal("1e-63"), name: "зептометров кубических" },
    { amount: new Decimal("1e-72"), name: "иоктометров кубических" },
    { amount: new Decimal("4.22419e-105"), name: "планковских объёмов" }
  ],

  macroObjects: [
    { amount: new Decimal("2.82e-45"), name: "протонов", verb: "изготовления" },
    { amount: new Decimal("1e-42"), name: "нуклеи", verb: "изготовления" },
    { amount: new Decimal("7.23e-30"), name: "атомов Водорода", verb: "изготовления" },
    { amount: new Decimal("5e-21"), name: "вирусов", verb: "изготовления" },
    { amount: new Decimal("9e-17"), name: "красных кровяных телец", verb: "изготовления" },
    { amount: new Decimal("6.2e-11"), name: "песчинок песка", verb: "изготовления" },
    { amount: new Decimal("5e-8"), name: "гранул риса", verb: "изготовления" },
    { amount: new Decimal("3.555e-6"), name: "чайных ложек", verb: "заполнения" },
    { amount: new Decimal("7.5e-4"), name: "бутылок вина", verb: "заполнения" },
    { amount: DC.D1, name: "морозилок", verb: "заполнения" },
    { amount: new Decimal("2.5e3"), name: "плавательного озера Олимпийских игр", verb: "заполнения" },
    { amount: new Decimal("2.6006e6"), name: "Великих Пирамид Гизы", verb: "изготовления" },
    { amount: new Decimal("3.3e8"), name: "Великих Стен Китая", verb: "изготовления" },
    { amount: new Decimal("5e12"), name: "больших астероидов", verb: "изготовления" },
    { amount: new Decimal("4.5e17"), name: "карликовых планет", verb: "изготовления" },
    { amount: new Decimal("1.08e21"), name: "Земель", verb: "изготовления" },
    { amount: new Decimal("1.53e24"), name: "Юпитеров", verb: "изготовления" },
    { amount: new Decimal("1.41e27"), name: "Солнц", verb: "изготовления" },
    { amount: new Decimal("5e32"), name: "красных Гигантов", verb: "изготовления" },
    { amount: new Decimal("8e36"), name: "гипергигантских звёзд", verb: "изготовления" },
    { amount: new Decimal("1.7e45"), name: "туманностей", verb: "изготовления" },
    { amount: new Decimal("1.7e48"), name: "облаков Оорта", verb: "изготовления" },
    { amount: new Decimal("3.3e55"), name: "Местных Пузырей", verb: "изготовления" },
    { amount: new Decimal("3.3e61"), name: "галактик", verb: "изготовления" },
    { amount: new Decimal("5e68"), name: "Местных Групп Галактик", verb: "изготовления" },
    { amount: new Decimal("1e73"), name: "Пустот Скульптра", verb: "изготовления" },
    { amount: new Decimal("3.4e80"), name: "метагалактик", verb: "изготовления" },
    { amount: new Decimal("1e113"), name: "Измерений", verb: "изготовления" },
    { amount: DC.C2P1024, name: "Измерений Бесконечности", verb: "изготовления" },
    { amount: new Decimal("1e65000"), name: "Измерений Времени", verb: "изготовления" }
  ]
};
